import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forWhom = ['Dacă vrei dezvoltare personală reală, cu tehnici pe care le aplici chiar a doua zi, nu doar teorie de citit.', 'Dacă ești coach, trainer, psiholog sau terapeut și vrei instrumente mai puternice de comunicare și schimbare.', 'Dacă ești lider, manager sau antreprenor și vrei să comunici mai clar, să influențezi mai uman și să gestionezi mai bine relațiile.', 'Dacă simți că ești blocat în tipare vechi și vrei o transformare practică, nu o altă carte despre mindset.', 'Dacă ai un program încărcat și ai nevoie de ceva organizat, un weekend pe lună, fără să îți dai viața peste cap.'];
const notForWhom = ['Dacă vrei doar să citești despre NLP, fără să exersezi și să aplici între module.', 'Dacă nu ești dispus să lucrezi cu tine însuți pe parcursul celor 7 luni.', 'Dacă vrei rezultate instant, fără implicare personală reală.', 'Dacă nu ești deschis la schimbare sau nu vrei să explorezi propriile tipare.', 'Dacă nu poți participa consecvent la toate modulele, programul nu va da rezultatele dorite.'];
export const ForWhom = () => {
  return <section className="py-16 bg-navy-dark relative overflow-hidden border-t border-gold/10" data-id="element-81">
      {/* Background image */}
      <div className="absolute inset-0 z-0" data-id="element-82">
        <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1920&q=80" alt="" className="w-full h-full object-cover opacity-[0.05]" data-id="element-83" />
        <div className="absolute inset-0 bg-navy-dark/90" data-id="element-84" />
      </div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-85">
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-86">
          {/* For Whom Column */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-navy-card border border-gold/30 p-8 relative overflow-hidden" data-id="element-87">
            <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-gold/50 via-gold to-gold/50" data-id="element-88" />
            <h3 className="font-serif text-4xl font-bold text-white mb-8" data-id="element-89">
              Pentru cine este programul
            </h3>
            <ul className="space-y-4" data-id="element-90">
              {forWhom.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-91">
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-92" />
                  <span className="font-sans text-white text-base leading-relaxed" data-id="element-93">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
          {/* Not For Whom Column */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-navy-card border border-gold/30 p-8 relative overflow-hidden" data-id="element-94">
            <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-gold/50 via-gold to-gold/50" data-id="element-95" />
            <h3 className="font-serif text-4xl font-bold text-textSub mb-8" data-id="element-96">
              Pentru cine nu este programul
            </h3>
            <ul className="space-y-4" data-id="element-97">
              {notForWhom.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-98">
                  <XCircle className="w-5 h-5 text-red-400/60 shrink-0 mt-0.5" data-id="element-99" />
                  <span className="font-sans text-white text-base leading-relaxed" data-id="element-100">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
};